import './style.sass';

import clsx from 'clsx';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const DefaultListImage = ({ listIntegration, customClass }) => {
    return (
        <FullWrapper className="default-list-image">
            <div className={clsx('default-list-imageWrapper', customClass)}>
                <div
                    dangerouslySetInnerHTML={{ __html: listIntegration.title }}
                    className="default-list-imageTitle"
                />
                {listIntegration.description && (
                    <div
                        dangerouslySetInnerHTML={{ __html: listIntegration.description }}
                        className="default-list-imageDescription"
                    />
                )}
                {listIntegration.list && (
                    <div className="default-list-imageList">
                        {listIntegration.list.map((item, index) => (
                            <div key={index} className="default-list-imageItem">
                                <div className="default-list-imageNumeric">{item.numeric}</div>
                                <div className="default-list-imageContent">
                                    {item.subtitle && (
                                        <div
                                            dangerouslySetInnerHTML={{ __html: item.subtitle }}
                                            className="default-list-imageSubtitle"
                                        />
                                    )}
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.text }}
                                        className="default-list-imageText"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {listIntegration.picture && (
                    <img
                        className="default-list-imagePicture"
                        alt={listIntegration.title}
                        src={listIntegration.picture}
                    />
                )}
                {listIntegration.secondList && (
                    <div className="default-list-imageList">
                        {listIntegration.secondList.map((item, index) => (
                            <div key={index} className="default-list-imageItem">
                                <div className="default-list-imageNumeric">{item.numeric}</div>
                                <div className="default-list-imageContent">
                                    {item.subtitle && (
                                        <div
                                            dangerouslySetInnerHTML={{ __html: item.subtitle }}
                                            className="default-list-imageSubtitle"
                                        />
                                    )}
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.text }}
                                        className="default-list-imageText"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {listIntegration.secondPicture && (
                    <img
                        className="default-list-imageSecondPicture"
                        alt={listIntegration.title}
                        src={listIntegration.secondPicture}
                    />
                )}
                {/*{listIntegration.thirdPicture && (*/}
                {/*    <img*/}
                {/*        className="default-list-imageThirdPicture"*/}
                {/*        alt={listIntegration.title}*/}
                {/*        src={listIntegration.thirdPicture}*/}
                {/*    />*/}
                {/*)}*/}
            </div>
        </FullWrapper>
    );
};

export default DefaultListImage;
